import { PdMenu } from "./pd-menu/PdMenu.js";
//#region src/pd-menu/pd-menu.ts
var tag = "pd-menu";
if (!customElements.get(tag)) customElements.define(tag, PdMenu);
//#endregion
export { PdMenu };
